import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sucesso',
  standalone: true,
  imports: [],
  templateUrl: './sucesso.component.html',
  styleUrls: ['./sucesso.component.scss'],
})
export class SucessoComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Input() mensagem: string = 'Ação realizada com sucesso!';
  @Input() botaoTexto: string = 'Continuar';
  @Output() continuar = new EventEmitter<void>();
}
